import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const LinkElement = styled.a`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const Link = props => <LinkElement {...props}>{props.children}</LinkElement>;

Link.propTypes = {
    children: PropTypes.object.isRequired
};

export default Link;
